<script setup>
import { Button, Icon, Typography } from '@aryeo/runway'
import ConstellationModal from '@/Components/Constellation/Modals/ConstellationModal.vue'
import { computed, ref } from 'vue'

const props = defineProps({
  bookingIntent: {
    type: Object,
    required: true,
  },
  order: {
    type: Object,
    default: () => {},
  },
})

const showExitModal = ref(false)

const redirectToShowingTimePlus = () => {
  window.location.href =
    props.bookingIntent.showingtimeplus_core_engagement.showingtimeplus_redirect_url
}

const handleExitClick = () => {
  if (shouldConfirmExit.value) {
    showExitModal.value = true

    return
  }

  redirectToShowingTimePlus()
}

const shouldConfirmExit = computed(() => !props.order || props.order.status === 'draft')

const address = computed(
  () => props.bookingIntent?.address?.unparsed_address || props.order?.address?.unparsed_address
)
</script>

<template>
  <div class="w-full bg-white p-4 lg:px-16 flex items-center justify-between">
    <div class="flex flex-col">
      <div class="flex items-center gap-2" v-if="bookingIntent.is_showcase">
        <Icon name="sparkles" color="marketplace" />
        <Typography variant="h2">Create a Showcase listing</Typography>
      </div>
      <Typography variant="h2" v-else>Order media</Typography>
      <Typography variant="body">{{ address }}</Typography>
    </div>

    <div class="inline-block border border-gray-300 rounded transition-colors">
      <Button color="white" text="Exit" @click="handleExitClick" />
    </div>
  </div>

  <teleport to="body">
    <ConstellationModal
      title="Exit order"
      confirmText="Exit order"
      cancelText="Complete order"
      :isOpen="showExitModal"
      @onClose="showExitModal = false"
      @onCancel="showExitModal = false"
      @onConfirm="redirectToShowingTimePlus"
    >
      <span class="font-normal">
        Your order is incomplete. Do you want to exit without completing your order?
      </span>
    </ConstellationModal>
  </teleport>
</template>
